(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mat-board-modal"] && !Shopify.designMode) return;
  try {
    (function () {
  function init() {
    document.querySelectorAll('.sc-modal').forEach(function (modal) {
      var id = modal.id;

      document.querySelectorAll('.sc-trigger[data-modal-id="' + id + '"]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          modal.setAttribute('aria-hidden', 'false');
          modal.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        });
      });

      modal.querySelectorAll('[data-sc-close]').forEach(function (el) {
        el.addEventListener('click', function () { closeModal(modal); });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal(modal);
      });
    });
  }

  function closeModal(modal) {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-chart-modal"] && !Shopify.designMode) return;
  try {
    (function () {
  function init() {
    document.querySelectorAll('.sc-modal').forEach(function (modal) {
      var id = modal.id;

      /* open */
      document.querySelectorAll('.sc-trigger[data-modal-id="' + id + '"]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          /* mark currently selected pill */
          var checked = document.querySelector(
            'input[type="radio"][data-current-checked="true"], input[type="radio"]:checked'
          );
          modal.querySelectorAll('.sc-pill').forEach(function (p) {
            p.classList.toggle('is-selected', checked && p.dataset.scValue === checked.value);
          });
          modal.setAttribute('aria-hidden', 'false');
          modal.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        });
      });

      /* close */
      modal.querySelectorAll('[data-sc-close]').forEach(function (el) {
        el.addEventListener('click', function () { closeModal(modal); });
      });

      /* close on Escape */
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal(modal);
      });

      /* select size from modal */
      modal.querySelectorAll('.sc-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          var value = pill.dataset.scValue;
          /* find and click the matching radio in the variant picker */
          var radio = document.querySelector('input[type="radio"][value="' + value + '"]');
          if (radio) {
            radio.checked = true;
            radio.click();
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
          /* update pill highlight */
          modal.querySelectorAll('.sc-pill').forEach(function (p) {
            p.classList.toggle('is-selected', p === pill);
          });
          if (pill.hasAttribute('data-sc-close-on-select')) closeModal(modal);
        });
      });
    });
  }

  function closeModal(modal) {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
